import React from 'react';
import { AppBar, Box, SvgIcon, Tab, Tabs } from '@mui/material';
import { Colors } from '../../../utils/theme';
import { SvgIconComponent } from '@mui/icons-material';
import { getInfoWrapperTabStyle, getOuterStyle, getTabStyle } from '../../../utils/styleUtils';

interface IProps {
  value: number;
  handleChange: (_: unknown, newValue: number) => void;
  tabProps: ITabProps[];
  type?: 'first' | 'second' | 'third'; // first is the top blue one | second is the top non blue (membership details) | third is the in details paper box
}

interface ITabProps {
  id: string;
  icon?: SvgIconComponent;
  title: string;
}

const CustomAppBar: React.FunctionComponent<IProps> = ({
  value,
  handleChange,
  tabProps,
  type = 'second'
}) => {
  const textColoring = type === 'first' ? 'inherit' : 'primary';
  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: type === 'first' ? Colors.gradient : 'white',
        boxShadow: type === 'third' ? 'none' : 'default'
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor={textColoring}
        variant="fullWidth"
        TabIndicatorProps={{
          sx:
            type === 'first'
              ? { background: Colors.skyBlue, height: '6px' }
              : type === 'second'
              ? { background: Colors.main }
              : { background: Colors.white }
        }}
      >
        {tabProps.map((tab, index) => (
          <Tab
            key={index}
            id={tab.id}
            label={
              <Box className="centralize">
                {tab.icon && <SvgIcon component={tab.icon} sx={{ marginRight: '5px' }} />}
                <Box>{tab.title}</Box>
              </Box>
            }
            sx={
              type === 'first'
                ? getInfoWrapperTabStyle(index, value)
                : type === 'second'
                ? getOuterStyle(index, value)
                : getTabStyle(index, value)
            }
          />
        ))}
      </Tabs>
    </AppBar>
  );
};

export default CustomAppBar;
